import { render, staticRenderFns } from "./releasedata.vue?vue&type=template&id=f7e9e79c&scoped=true&"
import script from "./releasedata.vue?vue&type=script&lang=js&"
export * from "./releasedata.vue?vue&type=script&lang=js&"
import style0 from "./releasedata.vue?vue&type=style&index=0&id=f7e9e79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e9e79c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VDialog,VRow,VSelect})
